
import React from 'react';
import ReactDOM from 'react-dom/client'
import { HelpUProps, HelpUComponent } from './HelpUComponent';


function renderHelpUComponent(props: HelpUProps) {
    document.getElementById('profileWrapper')?.remove();

    let element = document.createElement('div');
    element.setAttribute("id","helpUWrapper")
    document.body.appendChild(element);
    
    ReactDOM.createRoot(element as HTMLElement).render(
        <HelpUComponent 
            isOpen={props?.isOpen ?? true}
            product={props?.product}
            locale={props?.locale}
            source={props?.source}
            authToken={props?.authToken}
            releaseNotesId={props?.releaseNotesId}
            title={props?.title}
            env={props?.env}
             />
    )
}
function closeHelpUComponent() {
    document.getElementById('helpUWrapper')?.remove();
}


// @ts-ignore
window.renderHelpUComponent = renderHelpUComponent;
// @ts-ignore
window.closeHelpUComponent = closeHelpUComponent;

export {
    renderHelpUComponent,
    closeHelpUComponent
}